import {
  Box,
  Button,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  capitalize,
  useTheme,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  closeModal,
  filterFunc,
  filterMethod,
  setFilterItems,
} from "../../redux/actions/actions";
import { getTheme } from "../../styles/theme";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

export default function FilterModal2({ filterMethods }) {
  const { t, i18n } = useTranslation();

  const selectedFilters = useSelector((state) => state.filters.selectedFilters); // Arama terimini al
  const [filters, setFilters] = useState(selectedFilters || null);
  const selectedBranchesString = useSelector(
    (state) => state?.branches?.branchesString
  );
  const pageType = useSelector((state) => state.filters.pageType);
  const searchedTerm = useSelector((state) => state.searchTerm.searchTerm); // Arama terimini al

  const [selectedRange, setSelectedRange] = useState(
    !Object.keys(filters).length
      ? "filter_by_none"
      : filters?.created_at_range_after || filters?.created_at_range_before
        ? "filter_by_date_range"
        : filters?.check_in || filters?.check_out
          ? "filter_by_none"
          : null
  );

  // const [selectedRange, setSelectedRange] = useState(
  //   filters?.created_at
  //     ? filters?.created_at
  //     : filters?.created_at_range_after || filters?.created_at_range_before
  //     ? "filter_by_date_range"
  //     : "filter_by_none"
  // );
  const rangeTypes = [
    "created_at_range_after",
    "created_at_range_before",
    "check_in",
    "check_out",
  ];
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      Object.keys(filters).length === 0 &&
      selectedRange !== "filter_by_none" &&
      selectedRange !== "filter_by_date_range"
    ) {
      setSelectedRange("filter_by_none");
    }

    // if (filters?.range_types === "filter_by_none") {
    //   console.log("filter by none detected");

    //   // filters objesinden 'range_types' özelliğini kaldırma
    //   const newFilters = { ...filters };
    //   delete newFilters.range_types;

    //   // filters içindeki rangeTypes dizisindeki öğeleri kaldırma
    //   rangeTypes.forEach((type) => {
    //     if (newFilters[type]) {
    //       delete newFilters[type];
    //     }
    //   });

    //   // Yeni filters objesini güncelleme
    //   setFilters(newFilters);
    //   //dispatch(newFilters);
    // }
  }, [filters]);

  const setFilter = (key, value) => {
    setFilters((prev) => {
      const newFilters = { ...prev };

      // Geçerli bir tarih nesnesi oluşturup geçerliliğini kontrol et
      const date = value ? dayjs(value) : null;
      // if (date && !date.isValid()) {
      //   // Eğer tarih geçerli değilse, bir işlem yapma
      //   console.error('Invalid date detected:', value);
      //   return prev; // Geçerli olmayan tarih için güncelleme yapmadan önceki state'i geri döndür
      // }

      if (value === "") {
        // Eğer value boşsa, bu anahtarı filtrelerden çıkar
        delete newFilters[key];
      } else {
        // Eğer value doluysa ve geçerliyse, filtreyi güncelle
        newFilters[key] = value;
      }

      return newFilters;
    });
  };

  const handleClose = () => {
    dispatch(closeModal());
  };

  const handleSubmit = () => {
    // dispatch(
    //   filterFunc(filters, pageType, searchedTerm, selectedBranchesString)
    // );
    dispatch(setFilterItems(filters));
    handleClose();
  };

  const handleRemoveFilters = () => {
    if (Object.keys(searchedTerm).length) {
      dispatch(filterFunc({}, pageType, searchedTerm, selectedBranchesString));
    }
    // dispatch(filterFunc({}, pageType, searchedTerm, selectedBranchesString));
    dispatch(setFilterItems({}));
    handleClose();
  };

  // const formatFilterValue = (key, value) => {
  //   if (
  //     key === "check_in" ||
  //     key === "check_out" ||
  //     key === "lastPaymentDate" ||
  //     key === "issue_date" ||
  //     key === "created_at_range_before" ||
  //     key === "created_at_range_after"
  //   ) {
  //     const date = dayjs(value);
  //     // Dayjs objesinin geçerli bir tarih olup olmadığını kontrol et
  //     return date.format("DD MMMM YYYY");
  //     // Geçersiz bir tarih ise boş string döndür
  //   }
  //   return value;
  // };

  const dayjs = require("dayjs"); // Eğer dayjs'i kullanmadıysanız, yüklemeniz gerekir.

  const formatFilterValue = (key, value) => {
    const cleanValue =
      typeof value === "string"
        ? capitalize(value.replace(/[^a-zA-Z0-9\s]/g, " "))
        : value;

    // Anahtar isimlerini kullanıcı dostu metinlere çevir
    const keyMappings = {
      check_in: t("checkIn"),
      check_out: t("checkOut"),
      lastPaymentDate: t("lastPaymentDate"),
      issue_date: t("issueDate"),
      occupancy: t("occupancy"),
      duration: t("duration"),
      student_name: t("studentName"),
      discount_name: t("discountName"),
      requester: t("requester"),
      created_at: t("createdAt"),
      status: t("status"),
      created_at_range_before: t("createdAtRangeBefore"),
      created_at_range_after: t("createdAtRangeAfter"),
      issue_date_before: t("issueDateBefore"),
      issue_date_after: t("issueDateAfter"),
      booking_type: t("bookingType"),
      type: t("invoiceType"),
    };

    // Anahtar tarihle ilgiliyse ve geçerli bir tarihse, formatla ve dönüş yap
    if (key in keyMappings) {
      const date = dayjs(value);
      if (
        key === "check_in" ||
        key === "check_out" ||
        key === "lastPaymentDate" ||
        key === "issue_date" ||
        key === "created_at_range_before" ||
        key === "created_at_range_after" ||
        key === "issue_date_before" ||
        key === "issue_date_after"
      ) {
        // Eğer tarih geçerliyse formatı uygula
        return { key: keyMappings[key], value: date.format("DD MMMM YYYY") };
      } else {
        // Geçersiz bir tarih ise boş string döndür

        console.log(cleanValue, 'clean value');

        return { key: keyMappings[key], value: cleanValue };
      }
    }

    // Tarihle ilgili olmayan anahtarlar için, kullanıcı dostu anahtar adı döndür
    return { key: keyMappings[key] || key, cleanValue };
  };

  const handleDelete = (key) => {
    if (Object.keys(filters).length) {
      setFilters((prev) => {
        const newFilters = { ...prev };
        delete newFilters[key];
        return newFilters;
      });
    }
  };

  const normalizeValue = (value) => {
    const map = {
      Fullypaid: 'Full Paid',
      Depositpaid: 'Deposit Paid',
      Partiallypaid: 'Partially Paid',
      Overdue: 'Over Due',
      Overpaid: 'Over Paid',
      Unpaid: 'Un Paid',
    };

    return map[value] || value;
  };

  const toCamelCase = (str) => {
    return normalizeValue(str)
      .toLowerCase()
      .replace(/[^a-zA-Z0-9 ]/g, '')
      .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
        index === 0 ? word.toLowerCase() : word.toUpperCase()
      )
      .replace(/\s+/g, '');
  };


  const theme = useTheme();
  // useEffect(() => {
  //   console.log(selectedRange, "selected Range");
  //   console.log(pageType, "page type");
  // }, [selectedRange]);


  useEffect(() => {
    if (i18n.language) {
      dayjs.locale(i18n.language);
    }
  }, [i18n.language]);
  return (
    <Box>
      {Object.keys(filters).length ? (
        <Box
          sx={{
            marginBottom: "1rem",
          }}
        >
          <Typography
            sx={{ lineHeight: "1rem", textTransform: 'capitalize' }}
            variant="h6"
            color={theme.palette.primary.main}
          >
            {t("selectedFilters")}
          </Typography>
          <Box display="flex" mt={2} flexWrap="wrap" gap={1}>
            {Object.entries(filters).map(([key, value]) => {
              console.log(toCamelCase((formatFilterValue(key, value).value)), 'BB');
              return (
                <>
                  <Chip
                    sx={{ textTransform: 'capitalize' }}
                    key={key}
                    label={`${formatFilterValue(key, value).key} : ${t(toCamelCase(formatFilterValue(key, value).value))}
                      `}
                    onDelete={() => handleDelete(key)}
                    deleteIcon={<CloseIcon />}
                    color="primary"
                    variant="outlined"
                  />
                </>
              )
            }
            )}
          </Box>
        </Box>
      ) : null}

      {filterMethods?.map((filterMethod, idx) => {
        return (
          <>
            {filterMethod == "range_types" && (
              <>
                <FormControl
                  fullWidth
                  sx={{ marginTop: "1rem", marginBottom: "1rem" }}
                >
                  <InputLabel id="range_types">{t("rangeTypes")}</InputLabel>
                  <Select
                    labelId="range_types"
                    id="range_types"
                    value={
                      !filters?.created_at
                        ? selectedRange
                        : filters.created_at || filters.created_at
                    }
                    label={t("rangeTypes")}
                    // onChange={(range_types) => {
                    //   if (
                    //     ["today", "week", "month", "year"].includes(
                    //       range_types.target.value
                    //     )
                    //   ) {
                    //     setSelectedRange();
                    //     const newFilters = { ...filters };
                    //     rangeTypes.forEach((type) => {
                    //       if (newFilters[type]) {
                    //         delete newFilters[type];
                    //       }
                    //     });
                    //   setFilters("created_at", range_types.target.value, newFilters);

                    //   } else {
                    //     setSelectedRange(range_types.target.value);
                    //     const newFilters = { ...filters };
                    //     delete newFilters.created_at;
                    //       rangeTypes.forEach((type) => {
                    //         if (newFilters[type]) {
                    //           delete newFilters[type];
                    //         }
                    //       });
                    //     setFilters(newFilters);
                    //   }
                    // }}

                    onChange={(e) => {
                      const newRange = e.target.value;

                      const newFilters = { ...filters };

                      if (
                        ["today", "week", "month", "year"].includes(newRange)
                      ) {
                        // Eğer seçilen range bugün, bu hafta, bu ay veya bu yıl ise
                        setSelectedRange();
                        rangeTypes.forEach((type) => {
                          if (newFilters[type]) {
                            delete newFilters[type]; // Tarih aralığı filtrelerini kaldır
                          }
                        });
                        newFilters["created_at"] = newRange; // created_at filtresini ayarla
                      } else {
                        // Eğer seçilen range tarih aralığı değilse
                        setSelectedRange(newRange);
                        delete newFilters.created_at; // created_at filtresini kaldır
                        rangeTypes.forEach((type) => {
                          if (newFilters[type]) {
                            delete newFilters[type]; // Tarih aralığı filtrelerini kaldır
                          }
                        });
                      }

                      setFilters(newFilters); // Yeni filtreler ile state'i güncelle
                    }}
                  >
                    <MenuItem value={"range_types"} disabled>
                      {t("rangeTypes")}
                    </MenuItem>
                    <MenuItem selected value={"filter_by_none"}>
                      {t("none")}
                    </MenuItem>

                    <MenuItem value={"filter_by_date_range"}>
                      {t("filterByDateRange")}
                    </MenuItem>
                    <MenuItem value={"today"}>{t("filterByToday")}</MenuItem>
                    <MenuItem value={"week"}>{t("filterByPastSevenDays")}</MenuItem>
                    <MenuItem value={"month"}>{t("filterByThisMonth")}</MenuItem>
                    <MenuItem value={"year"}>{t("filterByThisYear")}</MenuItem>
                  </Select>
                </FormControl>

                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  adapterLocale={i18n.language === "cn" ? "zh-cn" : i18n.language}>
                  {selectedRange ? (
                    selectedRange === "filter_by_date_range" ? (
                      <>
                        <DemoContainer
                          sx={{
                            display: "flex",
                            flexDirection: "column !important",
                          }}
                          components={["DatePicker"]}
                        >
                          <DatePicker
                            label={t("startDate")}
                            value={filters?.created_at_range_after || null}
                            // onChange={(date) =>
                            //   setFilter("created_at_range_after", date)
                            // }
                            onChange={(newValue) => {
                              const date = newValue ? dayjs(newValue) : null;
                              let endDate = filters.created_at_range_before
                                ? dayjs(filters.created_at_range_before)
                                : null;
                              if (endDate && date && date.isAfter(endDate)) {
                                // Eğer yeni başlangıç tarihi, bitiş tarihinden sonra ise, bitiş tarihini başlangıç tarihine eşitle
                                setFilter("created_at_range_after", endDate);
                              } else {
                                setFilter("created_at_range_after", date);
                              }
                            }}
                            maxDate={filters?.created_at_range_before || null}
                          />
                        </DemoContainer>

                        <DemoContainer
                          sx={{
                            display: "flex",
                            flexDirection: "column !important",
                          }}
                          components={["DatePicker"]}
                        >
                          <DatePicker
                            label={t("endDate")}
                            value={filters?.created_at_range_before || null}
                            // onChange={(date) =>
                            //   setFilter("created_at_range_before", date)
                            // }
                            onChange={(newValue) => {
                              const date = newValue ? dayjs(newValue) : null;
                              let startDate = filters.created_at_range_after
                                ? dayjs(filters.created_at_range_after)
                                : null;
                              if (
                                startDate &&
                                date &&
                                date.isBefore(startDate)
                              ) {
                                // Eğer yeni bitiş tarihi, başlangıç tarihinden önce ise, başlangıç tarihini bitiş tarihine eşitle
                                setFilter("created_at_range_before", startDate);
                              } else {
                                setFilter("created_at_range_before", date);
                              }
                            }}
                            minDate={filters?.created_at_range_after || null}
                          />
                        </DemoContainer>
                      </>
                    ) : pageType !== "partner_requests" ? (
                      <>
                        <DemoContainer
                          sx={{
                            display: "flex",
                            flexDirection: "column !important",
                          }}
                          components={["DatePicker"]}
                        >
                          <DatePicker
                            label={t("checkIn")}
                            value={filters?.check_in || null}
                            onChange={(newValue) => {
                              const date = newValue ? dayjs(newValue) : null;
                              let endDate = filters?.check_out
                                ? dayjs(filters?.check_out)
                                : null;
                              if (endDate && date && date.isAfter(endDate)) {
                                // Eğer yeni başlangıç tarihi, bitiş tarihinden sonra ise, bitiş tarihini başlangıç tarihine eşitle
                                setFilter("check_in", endDate);
                              } else {
                                setFilter("check_in", date);
                              }
                            }}
                            // onChange={(date) => setFilter("check_in", date)}
                            maxDate={filters?.check_out || null}
                          />
                        </DemoContainer>

                        <DemoContainer
                          sx={{
                            display: "flex",
                            flexDirection: "column !important",
                          }}
                          components={["DatePicker"]}
                        >
                          <DatePicker
                            label={t("checkOut")}
                            value={filters?.check_out || null}
                            onChange={(newValue) => {
                              const date = newValue ? dayjs(newValue) : null;
                              let startDate = filters.check_in
                                ? dayjs(filters.check_in)
                                : null;
                              if (
                                startDate &&
                                date &&
                                date.isBefore(startDate)
                              ) {
                                // Eğer yeni bitiş tarihi, başlangıç tarihinden önce ise, başlangıç tarihini bitiş tarihine eşitle
                                setFilter("check_out", startDate);
                              } else {
                                setFilter("check_out", date);
                              }
                            }}
                            minDate={filters?.check_in || null}

                          // onChange={(newValue) => {
                          //   const date = newValue ? dayjs(newValue) : null;
                          //   let startDate = filters?.check_in
                          //     ? dayjs(filters?.check_in)
                          //     : null;
                          //   if (
                          //     startDate &&
                          //     date &&
                          //     date.isBefore(startDate)
                          //   ) {
                          //     // Eğer yeni başlangıç tarihi, bitiş tarihinden sonra ise, bitiş tarihini başlangıç tarihine eşitle
                          //     setFilter("check_out", startDate);
                          //   } else {
                          //     setFilter("check_out", date);
                          //   }
                          // }}
                          // onChange={(date) => setFilter("check_out", date)}
                          />
                        </DemoContainer>
                      </>
                    ) : null
                  ) : null}

                  {/* <DemoContainer
                  sx={{ display: "flex", flexDirection: "column !important" }}
                  components={["DatePicker"]}
                >
                  {filterMethod == "issue_date" && (
                    <DatePicker
                      label="Issue Date"
                      value={filters?.issue_date || null}
                      onChange={(date) => setFilter("issue_date", date)}
                    />
                  )}
                </DemoContainer> */}
                </LocalizationProvider>
              </>
            )}

            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale={i18n.language === "cn" ? "zh-cn" : i18n.language}>
              {filterMethod == "check_out" && (
                <DemoContainer
                  sx={{
                    display: "flex",
                    flexDirection: "column !important",
                  }}
                  components={["DatePicker"]}
                >
                  <DatePicker
                    label={t("checkOut")}
                    value={filters?.check_out || null}
                    onChange={(date) => setFilter("check_out", date)}
                    minDate={filters?.check_in || null}
                  />
                </DemoContainer>
              )}

              {filterMethod == "check_in" && (
                <DemoContainer
                  sx={{
                    display: "flex",
                    flexDirection: "column !important",
                  }}
                  components={["DatePicker"]}
                >
                  <DatePicker
                    label={t("checkIn")}
                    value={filters?.check_in || null}
                    onChange={(date) => setFilter("check_in", date)}
                    maxDate={filters?.check_out || null}
                  />
                </DemoContainer>
              )}

              {filterMethod == "issue_date" && (
                <>
                  {/* <DemoContainer
                    sx={{
                      display: "flex",
                      flexDirection: "column !important",
                    }}
                    components={["DatePicker"]}
                  >
                    <DatePicker
                      label="Issue Date"
                      value={filters?.issue_date || null}
                      onChange={(date) => setFilter("issue_date", date)}
                    />
                  </DemoContainer> */}

                  <>
                    <DemoContainer
                      sx={{
                        display: "flex",
                        flexDirection: "column !important",
                      }}
                      components={["DatePicker"]}
                    >
                      <DatePicker
                        label={t("issueDateStart")}
                        value={filters?.issue_date_after || null}
                        // onChange={(date) =>
                        //   setFilter("issue_date_after", date)
                        // }
                        onChange={(newValue) => {
                          const date = newValue ? dayjs(newValue) : null;
                          let endDate = filters.issue_date_before
                            ? dayjs(filters.issue_date_before)
                            : null;
                          if (endDate && date && date.isAfter(endDate)) {
                            // Eğer yeni başlangıç tarihi, bitiş tarihinden sonra ise, bitiş tarihini başlangıç tarihine eşitle
                            setFilter("issue_date_after", endDate);
                          } else {
                            setFilter("issue_date_after", date);
                          }
                        }}
                        maxDate={filters?.issue_date_before || null}
                      />
                    </DemoContainer>

                    <DemoContainer
                      sx={{
                        display: "flex",
                        flexDirection: "column !important",
                      }}
                      components={["DatePicker"]}
                    >
                      <DatePicker
                        label={t("issueDateEnd")}
                        value={filters?.issue_date_before || null}
                        // onChange={(date) =>
                        //   setFilter("issue_date_before", date)
                        // }
                        onChange={(newValue) => {
                          const date = newValue ? dayjs(newValue) : null;
                          let startDate = filters.issue_date_after
                            ? dayjs(filters.issue_date_after)
                            : null;
                          if (startDate && date && date.isBefore(startDate)) {
                            // Eğer yeni bitiş tarihi, başlangıç tarihinden önce ise, başlangıç tarihini bitiş tarihine eşitle
                            setFilter("issue_date_before", startDate);
                          } else {
                            setFilter("issue_date_before", date);
                          }
                        }}
                        minDate={filters?.issue_date_after || null}
                      />
                    </DemoContainer>
                  </>
                </>
              )}
            </LocalizationProvider>

            {filterMethod == "duration" && (
              <FormControl fullWidth sx={{ marginTop: "1rem" }}>
                <TextField
                  fullWidth
                  onChange={(duration) =>
                    setFilter("duration", duration.target.value)
                  }
                  id="duration"
                  label={t("duration")}
                  value={filters?.duration || ""}
                  variant="outlined"
                />
              </FormControl>
            )}

            {filterMethod == "student_name" && (
              <FormControl fullWidth sx={{ marginTop: "1rem" }}>
                <TextField
                  fullWidth
                  sx={{ textTransform: 'capitalize' }}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Sadece harfler ve boşluk karakterine izin ver
                    // if (/^[a-zA-Z\s]*$/.test(value)) {
                    if (/^[a-zA-ZçÇğĞıİöÖşŞüÜ\s]*$/.test(value)) {
                      setFilter("student_name", value);
                    }
                  }}
                  id="student_name"
                  label={t("studentName")}
                  value={filters?.student_name || ""}
                  variant="outlined"
                  type="text"
                />
              </FormControl>
            )}

            {filterMethod == "requester" && (
              <FormControl fullWidth sx={{ marginTop: "1rem" }}>
                <TextField
                  fullWidth
                  onChange={(e) => {
                    const value = e.target.value;
                    setFilter("requester", value);
                  }}
                  id="requester"
                  label={t("requester")}
                  value={filters?.requester || ""}
                  variant="outlined"
                  type="text"
                />
              </FormControl>
            )}

            {filterMethod == "discount_name" && (
              <FormControl fullWidth sx={{ marginTop: "1rem" }}>
                <TextField
                  sx={{ textTransform: 'capitalize' }}
                  fullWidth
                  onChange={(e) => {
                    const value = e.target.value;
                    setFilter("discount_name", value);
                  }}
                  id="discount_name"
                  label={t("discountName")}
                  value={filters?.discount_name || ""}
                  variant="outlined"
                  type="text"
                />
              </FormControl>
            )}

            {filterMethod == "status" && (
              <FormControl fullWidth sx={{ marginTop: "1rem" }}>
                <InputLabel id="status">{t("status")}</InputLabel>
                <Select
                  sx={{ textTransform: 'capitalize' }}
                  labelId="status"
                  id="status"
                  value={filters?.status || "status"}
                  label="status"
                  onChange={(status) =>
                    setFilter("status", status.target.value)
                  }
                >
                  <MenuItem value={"status"} disabled>
                    {t("status")}
                  </MenuItem>
                  {pageType === "discount_request"
                    ? [
                      <MenuItem value={"waiting_for_approval"}>
                        {t("waitingForApproval")}
                      </MenuItem>,
                      <MenuItem value={"approved"}>{t("approved")}</MenuItem>,
                      <MenuItem value={"declined"}>{t("declined")}</MenuItem>,
                    ]
                    : pageType === "quotes"
                      ? [
                        <MenuItem sx={{ textTransform: 'capitalize' }} value={"accepted"}>{t("accepted")}</MenuItem>,
                        <MenuItem sx={{ textTransform: 'capitalize' }} value={"draft"}>{t("draft")}</MenuItem>,
                        <MenuItem sx={{ textTransform: 'capitalize' }} value={"sent"}>{t("sent")}</MenuItem>,
                        <MenuItem sx={{ textTransform: 'capitalize' }} value={"declined"}>{t("declined")}</MenuItem>,
                        <MenuItem sx={{ textTransform: 'capitalize' }} value={"deposit_pending"}>
                          {t("depositPending")}
                        </MenuItem>,
                      ]
                      : [
                        <MenuItem
                          sx={{ textTransform: 'capitalize' }}
                          value={
                            pageType !== "commissions" ? "fullypaid" : "paid"
                          }
                        >
                          {pageType !== "commissions" ? t("fullyPaid") : "Paid"}
                        </MenuItem>,
                        pageType === "invoices" ? (
                          <MenuItem value={"canceled"}>{t("cancelled")}</MenuItem>
                        ) : null,
                        pageType !== "commissions"
                          ? [
                            <MenuItem sx={{ textTransform: 'capitalize' }} value={"depositpaid"}>
                              {t("depositPaid")}
                            </MenuItem>,

                            <MenuItem sx={{ textTransform: 'capitalize' }} value={"partiallypaid"}>
                              {t("partiallyPaid")}
                            </MenuItem>,
                            <MenuItem value={"overdue"}>{t("overDue")}</MenuItem>,
                            <MenuItem value={"overpaid"}>{t("overPaid")}</MenuItem>,
                          ]
                          : null,

                        <MenuItem value={"unpaid"}>{t("unPaid")}</MenuItem>,
                      ]}
                </Select>
              </FormControl>
            )}

            {filterMethod == "invoice_type" && (
              <FormControl fullWidth sx={{ marginTop: "1rem" }}>
                <InputLabel sx={{ textTransform: 'capitalize' }} id="invoice_type">{t("invoiceType")}</InputLabel>
                <Select
                  labelId="invoice_type"
                  id="invoice_type"
                  value={filters?.type || "type"}
                  label="invoice_type"
                  onChange={(invoice_type) =>
                    setFilter("type", invoice_type.target.value)
                  }
                >
                  <MenuItem sx={{ textTransform: 'capitalize' }} value={"type"} disabled>
                    {t("invoiceType")}
                  </MenuItem>
                  <MenuItem sx={{ textTransform: 'capitalize' }} value={"residence"}>{t("residence")}</MenuItem>,
                  <MenuItem sx={{ textTransform: 'capitalize' }} value={"service"}>{t("service")}</MenuItem>,
                </Select>
              </FormControl>
            )}

            {filterMethod == "booking_type" && (
              <FormControl fullWidth sx={{ marginTop: "1rem" }}>
                <InputLabel sx={{ textTransform: 'capitalize' }} id="booking_type">{t("bookingType")}</InputLabel>
                <Select
                  labelId="booking_type"
                  id="booking_type"
                  value={filters?.booking_type || "booking_type"}
                  label="booking_type"
                  onChange={(booking_type) =>
                    setFilter("booking_type", booking_type.target.value)
                  }
                >
                  <MenuItem sx={{ textTransform: 'capitalize' }} value={"booking_type"} disabled>
                    {t("bookingType")}
                  </MenuItem>
                  <MenuItem sx={{ textTransform: 'capitalize' }} value={"instant_booking"}>{t("instantBooking")}</MenuItem>
                  ,<MenuItem sx={{ textTransform: 'capitalize' }} value={"my_requests"}>{t("myRequests")}</MenuItem>,
                </Select>
              </FormControl>
            )}

            {filterMethod == "occupancy" && (
              <FormControl fullWidth sx={{ marginTop: "1rem" }}>
                <InputLabel id="occupancy">occupancy</InputLabel>
                <Select
                  labelId="occupancy"
                  id="occupancy"
                  value={filters?.occupancy || "occupancy"}
                  label="occupancy"
                  onChange={(occupancy) =>
                    setFilter("occupancy", occupancy.target.value)
                  }
                >
                  <MenuItem value={"occupancy"} disabled>
                    occupancy
                  </MenuItem>
                  <MenuItem value={true}>True</MenuItem>
                  <MenuItem value={false}>False</MenuItem>
                </Select>
              </FormControl>
            )}
          </>
        );
      })}
      <Button
        disabled={!Object.keys(filters).length}
        sx={{
          marginTop: "1rem",
          textTransform: 'capitalize'
        }}
        variant="contained"
        color="primary"
        fullWidth
        onClick={handleSubmit}
      >
        {t("submit")}
      </Button>
      <Button
        sx={{
          marginTop: "1rem",
          textTransform: 'capitalize'
        }}
        variant="contained"
        color="error"
        fullWidth
        disabled={!Object.keys(selectedFilters).length}
        onClick={handleRemoveFilters}
      >
        {t("clearFilters")}
      </Button>
      {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer
          sx={{ display: "flex", flexDirection: "column !important" }}
          components={["DatePicker"]}
        >
          <DatePicker
            label="Check In"
            value={selectedFilters?.check_in || filters?.check_in || null}
            onChange={(date) => setFilter("check_in", date)}
          />
          <DatePicker
            sx={{
              marginLeft: "0 !important",
              marginTop: "1rem !important",
            }}
            label="Check Out"
            value={selectedFilters?.checkOut || filters?.checkOut || null}
            onChange={(date) => setFilter("checkOut", date)}
          />
        </DemoContainer>
      </LocalizationProvider> */}
      {/* <FormControl fullWidth sx={{ marginTop: "1rem" }}>
        <InputLabel id="duration">Duration</InputLabel>
        <Select
          labelId="duration"
          id="duration"
          value={selectedFilters?.duration || filters?.duration || "Duration"}
          label="Duration"
          onChange={(duration) => setFilter("duration", duration.target.value)}
        >
          <MenuItem value={"Duration"} disabled>
            Duration
          </MenuItem>
          <MenuItem value={"10"}>10 Days</MenuItem>
          <MenuItem value={"20"}>20 Days</MenuItem>
          <MenuItem value={"30"}>30 Days</MenuItem>
          <MenuItem value={"40"}>40 Days</MenuItem>
          <MenuItem value={"50"}>50 Days</MenuItem>
        </Select>
        <Button
          sx={{
            marginTop: "1rem",
          }}
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </FormControl> */}
    </Box>
  );
}
